<template>
  <div class="input-group input-group-lg w-auto">
    <i class="fa-fw"
              :class="geoIconClass"
              ></i>

      <input
          id="geo-lookup"
          ref="lookupElement"
          placeholder="Ort"
          aria-label="Ort"
          autocomplete="off"
          class="form-control"
          type="text"
          name="geo"
          @blur="lookupFocused = false"
          @focus="lookupFocused = true"
          @keyup="setGeoLookup($event.target?.value)"
      />

      <ul id="geo-suggestion" :class="{ show: geoSuggestions.length > 0 && lookupFocused }" class="dropdown-menu">
        <li v-for="suggestion in geoSuggestions" :key="suggestion.loc_id">
          <a class="dropdown-item" @mousedown="setLocation(suggestion.text_val, suggestion.loc_id)">
            {{ suggestion.text_val }}
          </a>
        </li>
      </ul>

        <button
            aria-expanded="false"
            :class="['btn', 'btn-' + formDropdownClass, 'dropdown-toggle']"
            data-bs-toggle="dropdown"
            type="button"
        >
          {{ radii[radius] }}
          <span class="fa-light fa-chevron-down"></span>
        </button>
        <ul id="select-radius" class="dropdown-menu">
          <li v-for="(label, key) in radii" :key="key">
            <a
                :class="{ active: key === radius }"
                class="dropdown-item"
                @click="setLocationRadius(key)"
            >
              {{ label }}
            </a>
          </li>
        </ul>
    </div>

  <input type="hidden" name="geo-id" id="geo-id" :value=geoId>
  <input type="hidden" name="radius" id="radius" :value=radius>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import axios from "axios";

const props = defineProps<{
  geoLookup: string,
  formDropdownClass?: string,
  formDropdownText?: string,
  geoIconClass?:string,
}>()

const geoSuggestions = ref<Array<{ text_val: string; loc_id: number }>>([]);
const geo = ref("");
const geoId = ref("");
const radius = ref("");

const lookupElement = ref<HTMLInputElement>();
const lookupFocused = ref(false);

const setGeoLookup = async (value?: string) => {
  if (!value || value.length === 0) return;

  try {
    const response = await axios.post(props.geoLookup, null, {
      params: { search: value },
    });
    geoSuggestions.value = response.data;
  } catch (e) {
    geoSuggestions.value = [];
  }
};

const setLocation = (locationLabel: string, locationId: number) => {
  if (lookupElement.value) {
    lookupElement.value.value = locationLabel;
  }
  geo.value = locationLabel;
  geoId.value = locationId.toString();
};

const setLocationRadius = (newRadius: string) => {
  radius.value = newRadius;
};

// ---- Radii options ----
const radii: Record<string, string> = {
  "": props.formDropdownText,
  "10": "10km",
  "20": "20km",
  "30": "30km",
  "40": "40km",
  "50": "50km",
  "75": "75km",
  "100": "100km",
};
</script>
